import { Component, OnInit, Input } from '@angular/core';
import { SharedService } from 'src/app/shared/shared.service';
import { AppConstants } from 'src/app/config.service';
import { trigger, style, animate, transition, state } from '@angular/animations';
import * as moment from 'moment';
import { finalize } from 'rxjs/operators';
declare var Scheduler: any;
import { ToastService, IMyOptions } from 'ng-uikit-pro-standard';
import { UtilityService } from "../../shared/utility.service";
declare var dhtmlXMenuObject: any;

@Component({
    selector: 'scheduler',
    templateUrl: './scheduler.component.html',
    styleUrls: ['./scheduler.component.css'],
    animations: [
        trigger('hideShowAnimator', [
            state('true', style({ opacity: 1 })),
            state('false', style({ opacity: 0 })),
            transition('0 => 1', animate('.5s')),
            transition('1 => 0', animate('.9s'))
        ])
    ]
})
export class SchedulerComponent implements OnInit {


    menu: any = dhtmlXMenuObject;

    constructor(
        private service: SharedService,
        private appConstants: AppConstants,
        public toastr: ToastService,
        private utilityService: UtilityService
    ) { }


    ngOnInit() {
        /* this.loadCalendar(); */
    }


    @Input() accreditationInfo: any;
    isFromTabSection: boolean = false;

    ngOnChanges() {
        if (this.accreditationInfo && this.accreditationInfo.isFromTabSection) {
            this.isFromTabSection = true;
            if(this.sched)
            this.sched.clearAll()
            this.loadCalendar();
        }
        else if (this.accreditationInfo && !this.accreditationInfo.isFromTabSection) {
            if(this.sched)
            this.sched.clearAll()
            this.isFromTabSection = false;
            this.loadCalendar();
        }
    }


    

    async menuGeneration() {
        let that = this;
    
       
    
        let menuJson = [
    
          {
            id: '1',
            text: 'Reschedule',
            img: 'fa fa-undo'
          },
          {
            id: '2',
            text: 'Modify',
            img: 'fa fa-undo'
          },
          {
            id: '2',
            text: 'Cancel',
            img: 'fa fa-undo'
          },
          
        ]
        this.menu = new dhtmlXMenuObject();
        this.menu.setIconset("awesome");
        this.menu.setSkin("dhx_terrace");
        this.menu.renderAsContextMenu();
        this.menu.loadStruct(menuJson);
    
        this.sched.attachEvent("onEmptyClick", function (date, e) {
       
        });

            this.sched.attachEvent("onContextMenu", (event_id, native_event_object) => {
                let posx = 0;
                let posy = 0;
                this.menu.showContextMenu(posx, posy);
            });

                
        this.menu.attachEvent("onClick", (id, zoneId, cas) => {
        });
      }

    public sched: any;
    loadCalendar() {
        window.setTimeout(() => {
            // let height:any = document.getElementById('detailsColumn').style.height;
            // document.getElementById('schedule_here2').style.height = (height-100)+'px"';
            this.sched = Scheduler.getSchedulerInstance();
            this.sched.config.container_autoresize = false;
            this.sched.config.readonly = true;
            this.sched.init('schedule_here2', new Date(), "month");
            let that = this;
            this.menuGeneration();

            this.sched.attachEvent("onClick", function (id, e) {
                if (that.sched.getEvent(id).taskId !== null) {
                    that.sched._on_dbl_click(e);
                } else {
                    alert('Events can not be modified from the Activities Calendar.')
                }
                return false;
            });
        }, 300);

    }


    public datePickerOptions: IMyOptions = {
        dateFormat: 'mmm-dd-yyyy',
        closeAfterSelect: true,
        editableDateField: false
    };


    dateObj: any = {};
    isLoading: boolean = false;
    schedulerData: any = []
    getSchedulerData(): void {
        let params = { dateStarts: this.utilityService.toUTCDate(this.dateObj.dateStarts), dateEnds: this.utilityService.toUTCDate(this.dateObj.dateEnds) }
        if (this.accreditationInfo && this.accreditationInfo.isFromTabSection)
            params['accreditationIds'] = [this.accreditationInfo.id]
        this.isLoading = true;
        this.service.post(this.appConstants.endPoints.accreditationsEndPoint + "query-audit-events", {}, params)
            .pipe(finalize(() => {
                this.isLoading = false;
            }))
            .subscribe(response => {
                let schedulerData = response ? response : [];
                schedulerData.forEach(element => {
                    element.isNew = false;
                    element.text = element.name;
                    element.start_date = this.utilityService.changeDateFormat(new Date(element.dateStarts.dateMilliseconds), 'MM/DD/YYYY HH:mm');
                    element.end_date = this.utilityService.changeDateFormat(new Date(element.dateEnds.dateMilliseconds), 'MM/DD/YYYY HH:mm');
                    element.textColor = element.color ? element.color : "white"
                });
                let serialize = JSON.stringify(schedulerData);
                this.sched.parse(serialize, "json");
            }, res => {
                /*        this.errorService.errorHandling(res).then(res => {
                         this.error = res;
                       }); */
            })
    }

    show_minical() {
        if (this.sched.isCalendarVisible()) {
            this.sched.destroyCalendar();
        } else {
            this.sched.renderCalendar({
                position: "dhx_minical_icon",
                date: this.sched._date,
                navigation: true,
                handler: (date, calendar) => {
                    const startWeek = this.sched.getState().min_date;
                    const minStartDay = moment(startWeek).startOf('day');
                    const todayStartDay = moment(date).startOf('day');
                    const convertDate = moment(minStartDay).isSame(todayStartDay);
                    if (!convertDate) {
                        this.sched.setCurrentView(date);
                        this.dateObj.dateStarts = date
                        this.getSchedulerData();
                    }

                    this.sched.destroyCalendar()
                }
            });
        }
    };

}
